"use strict";
/**
 * All channels used by angular's WebWorker components are listed here.
 * You should not use these channels in your application code.
 */
exports.RENDERER_CHANNEL = 'ng-Renderer';
exports.EVENT_CHANNEL = 'ng-Events';
exports.ROUTER_CHANNEL = 'ng-Router';
//# sourceMappingURL=messaging_api.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/platform-browser/src/web_workers/shared/messaging_api.js
 ** module id = 89
 ** module chunks = 0
 **/